import React from 'react';

const withErrorBoundary = (WrappedComponent) =>
  class extends React.Component {
    state = { hasError: false };

    componentDidCatch(error) {
      // Report error to sentry
      if (process.env.NODE_ENV === 'production') {
        window.Sentry.captureException(error);
      }
      this.setState({ hasError: true });
    }

    render() {
      return <WrappedComponent {...this.props} hasError={this.state.hasError} />;
    }
  };

export default withErrorBoundary;
